// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3nLni","footer":"ModalFilter_footer__3ryOC"};